import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useCourseModuleList = (params?: any) => {
  return useQuery({
    queryKey: ['course-module-list', params],
    queryFn: async () => {
      const res = await request.get('/course-module', { params });
      return res.data;
    }
  });
};
